let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("72WHu")).then(() => parcelRequire('glQOK'));